import React from 'react';

export interface IYesNoProps {
  value: any;
}

export const YesNo = (props: IYesNoProps) => (<span>{props.value ? 'Yes' : 'No'}</span>);

YesNo.displayName = 'YesNo';
